import type { Tile } from './tile';

/**
 * Chunk size in hexes per axis. 8×8 = 64 hexes per chunk (ADR-0006).
 * Tunable — revisit if perf or topology issues surface.
 */
export const CHUNK_SIZE = 8;

/**
 * A chunk coordinate is the integer pair `(cq, cr)` such that
 * a tile at axial `(q, r)` lives in chunk `(floor(q / CHUNK_SIZE), floor(r / CHUNK_SIZE))`.
 */
export interface ChunkCoord {
  readonly cq: number;
  readonly cr: number;
}

export interface Chunk {
  readonly coord: ChunkCoord;
  readonly seed: number;
  /** Exactly `CHUNK_SIZE * CHUNK_SIZE` tiles, row-major in r then q. */
  readonly tiles: readonly Tile[];
}

export function chunkCoordOf(q: number, r: number): ChunkCoord {
  return {
    cq: Math.floor(q / CHUNK_SIZE),
    cr: Math.floor(r / CHUNK_SIZE),
  };
}

export function chunkKey(coord: ChunkCoord): string {
  return `${coord.cq},${coord.cr}`;
}
